import { theme } from "@xola/ui-kit";
import Highcharts from "highcharts";
import noDataToDisplay from "highcharts/modules/no-data-to-display";
import { merge } from "lodash";

noDataToDisplay(Highcharts);

const { colors } = theme;

export const fontStyle = {
    color: colors.gray.darker,
    fontSize: "12px",
    fontWeight: 400,
    cursor: "pointer",
    textOverflow: "ellipsis",
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
};

/**
 * This view sets up a Chart. A 'Chart' is anything Highcharts can render (graphs, pies, donuts etc)
 * This is the master file of defaults for Xola's charts. Colors, sizes, dimensions etc.
 */
export const BaseChartOptions = {
    global: {
        useUTC: false,
    },
    chart: {
        spacingLeft: 5,
    },
    colors: [
        colors.blue.DEFAULT, // blue
        colors.green.DEFAULT, // green
        colors.yellow.DEFAULT, // yellow
        colors.orange.DEFAULT, // orange
        colors.red.DEFAULT, // red
        colors.blue.darker, // Blue-darker
        colors.green.darker, // Green-darker
        colors.red.darker, // Red-darker
        colors.yellow.darker, // Yellow-darker
        colors.orange.darker, // Orange-darker
    ],
    xAxis: {
        title: { style: merge({}, fontStyle, { color: colors.black }) },
        labels: { style: fontStyle },
    },
    yAxis: {
        title: { style: merge({}, fontStyle, { color: colors.black }) },
        labels: { style: fontStyle },
    },
    tooltip: {
        enabled: true,
        backgroundColor: colors.black,
        borderColor: colors.black,
        borderRadius: 8,
        borderWidth: 1,
        valueDecimals: 2,
        crosshairs: [true, true], // Show cross hairs when you browse over the tooltips
        shadow: true,
        useHTML: true, // This is used to insert spans with classes for custom css
        style: merge({}, fontStyle, {
            color: colors.white,
            lineHeight: "16px",
        }),
    },
    title: {
        text: "", // No title by default
        style: merge({}, fontStyle, { color: colors.black, fontSize: "18px", fontWeight: 600 }),
    },
    plotOptions: {
        series: {
            // Markers are not shown by default, except when you hover
            // Width and radius of the marker when you hover
            marker: {
                enabled: true,
                states: { hover: { enabled: true, lineWidth: 1, radius: 4 } },
            },
        },
    },
    legend: {
        enabled: false, // By default legend is disabled
        itemStyle: fontStyle,
        align: "left", // Center it in the chart canvas
        layout: "horizontal", // Legend items are shown as a list
        borderWidth: 0,
    },
    credits: {
        // Don't show the 'Powered by Highcharts' text
        enabled: false,
    },
    lang: {
        noData: "No data to display",
    },
    noData: {
        position: {
            align: "center",
            verticalAlign: "middle",
            x: 0,
            y: 0,
        },
        style: {
            fontSize: "14px",
        },
    },
};
